module.exports = "<p>\n  default-guard works!\n</p>\n"